import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = ["innerHTML"]

import { computed } from 'vue';
import { FooterImagesItem } from '@/view/home/supportScript';
import { useGameStore } from '@/stores/games';


export default /*@__PURE__*/_defineComponent({
  __name: 'copyRightBar',
  props: {
    itemData: {}
  },
  emits: ['openContactPopup'],
  setup(__props: any, { emit: __emit }) {

function resolveText(text: string | Record<string, string>): string {
  if (typeof text === 'string') return text
  const lang = localStorage.getItem('lang') || 'en'
  return text[lang] || text['en'] || ''
}

function resolveImage(item: FooterImagesItem | Record<string, FooterImagesItem>): FooterImagesItem {
  if (!item) return { display: false, url: '', redirectUrl: '' }
  if ('url' in item) return item as FooterImagesItem
  const lang = localStorage.getItem('lang') || 'en'
  const localized = item as Record<string, FooterImagesItem>
  return localized[lang] || localized['en'] || { display: false, url: '', redirectUrl: '' }
}

const gameStore = useGameStore()
const props = __props
const emits = __emit

const footerImage1 = computed(() => resolveImage(props.itemData.footerImage1))
const footerImage2 = computed(() => resolveImage(props.itemData.footerImage2))
const copywriteDisplay = computed(() => props.itemData.htmlCopywriteText?.display ?? false)
const copywriteText = computed(() => resolveText(props.itemData.htmlCopywriteText?.text || ''))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (footerImage1.value.display)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: footerImage1.value.url,
          alt: "",
          width: "85%"
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    (footerImage2.value.display)
      ? (_openBlock(), _createElementBlock("img", {
          key: 1,
          src: footerImage2.value.url,
          alt: "",
          width: "70%",
          style: {"padding-top":"10px"}
        }, null, 8, _hoisted_3))
      : _createCommentVNode("", true),
    (copywriteDisplay.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          innerHTML: copywriteText.value
        }, null, 8, _hoisted_4))
      : _createCommentVNode("", true)
  ]))
}
}

})